import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { SupplierService } from '../_services';
import * as supplierActions from '../_actions/supplier';

@Injectable({
  providedIn: 'root',
})
export class SupplierEffects {
  loadSuppliers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(supplierActions.loadSuppliers),
      mergeMap(() =>
        this.supplierService.getSuppliers().pipe(
          map((suppliers) => supplierActions.loadSuppliersSuccess({ suppliers })),
          catchError((error) => of(supplierActions.loadSuppliersFailure({ error })))
        )
      )
    )
  );

  addsupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(supplierActions.addSupplier),
      mergeMap(({ supplier }) =>
        this.supplierService.saveSupplier(supplier).pipe(
          map((savedsupplier) => supplierActions.addSupplierSuccess({ supplier: savedsupplier })),
          catchError((error) => of(supplierActions.addSupplierFailure({ error })))
        )
      )
    )
  );

  updatesupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(supplierActions.updateSupplier),
      mergeMap(({ supplier }) =>
        this.supplierService.saveSupplier(supplier).pipe(
          map((updatedsupplier) =>
            supplierActions.updateSupplierSuccess({ supplier: updatedsupplier })
          ),
          catchError((error) => of(supplierActions.updateSupplierFailure({ error })))
        )
      )
    )
  );

  deletesupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(supplierActions.deleteSupplier),
      mergeMap(({ id }) =>
        this.supplierService.deleteSupplier(id).pipe(
          map(() => supplierActions.deleteSupplierSuccess({ id })),
          catchError((error) => of(supplierActions.deleteSupplierFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private supplierService: SupplierService
  ) {}
}
